<template>
  <div class="ruffle" />
</template>

<script>
export default {
  name: 'ruffle-icon'
}
</script>

<style lang="scss" scoped>
.ruffle {
  margin-top: -0.6px;
  width: 100%;
  height: 8px;
  background: url('~@/assets/player-ruffle.svg');
  background-repeat: repeat-x;
}
</style>
